import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

import i18n from '@/libs/i18n'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/acl'


import VueMoment from 'vue-moment';
Vue.use(VueMoment);

//Vuetify

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify);
export default new Vuetify({ })

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)


// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import dc charts css
require("../node_modules/dc/dist/style/dc.css")

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  vuetify : new Vuetify(),
  render: h => h(App),
}).$mount('#app')
